import React, { useState } from "react";
import View from "./View";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import ColorPicker from "./ColorPicker";
import Swal from "sweetalert2";

const initialState = {
  name: "",
  color: "#FFFFFF",
  themeImageDesktop: "",
  themeImageMobile: "",
  themeAnimationLink: "",
  iconColor: "#212121",
  textColor: "#212121",
  borderRadius: 30,
  linkBackgroundColor: "#ccc",
  background: 1,
  from: 1,
};

const ThemeForm = (props) => {
  const { title } = props;
  const { id } = useParams();
  const nav = useNavigate();
  const [themeDesign, setThemeDesign] = useState(initialState);
  const [backgroundState, setBackgroundState] = useState(1);
  const [themeUsers, setThemeUsers] = useState(0);
  const [dbgSelectedImage, setDBGSelectedImage] = useState({
    link: "",
    blob: "",
    details: null,
  });
  const [mbgSelectedImage, setMBGSelectedImage] = useState({
    link: "",
    blob: "",
    details: null,
  });
  const [scriptSelected, setScriptSelected] = useState({
    link: "",
    blob: "",
    details: null,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const themeHandleChange = (event) => {
    const { name, value } = event.target;
    setThemeDesign((prev) => ({ ...prev, [name]: value }));
  };

  const backgroundHandleChange = (val) => {
    setBackgroundState(val);
  };

  const changeBackgroundImage = (e, val) => {
    if (val === 1) {
      let fileToUpload = e.target.files[0];
      const DesktopJpgOrPng =
        fileToUpload.type === "image/png" || fileToUpload.type === "image/jpg";
      const objectUrl = URL.createObjectURL(fileToUpload);
      // setPreview(objectUrl);
      if (!DesktopJpgOrPng) {
        Swal.fire({
          title: "Warning!",
          text: "Please upload file having extension .jpg or .png only",
          icon: "warning",
          cancelButtonColor: "#ff0000",
        });
      } else {
        let reader = new FileReader();
        reader.onload = (event) => {
          setDBGSelectedImage({
            link: objectUrl,
            blob: event.target.result,
            details: {
              type: fileToUpload.type,
              name: fileToUpload.name,
              size: fileToUpload.size,
            },
          });
        };
        reader.readAsDataURL(fileToUpload);
        Swal.fire({
          title: "success!",
          text: "Successfully uploaded",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
      }
    } else if (val === 2) {
      let fileToUpload = e.target.files[0];
      const MobileJpgOrPng =
        fileToUpload.type === "image/png" || fileToUpload.type === "image/jpg";
      if (!MobileJpgOrPng) {
        Swal.fire({
          title: "Warning!",
          text: "Please upload file having extension .jpg or .png only",
          icon: "warning",
          cancelButtonColor: "#ff0000",
        });
      } else {
        const objectUrl = URL.createObjectURL(fileToUpload);
        let reader = new FileReader();
        reader.onload = (event) => {
          setMBGSelectedImage({
            link: objectUrl,
            blob: event.target.result,
            details: {
              type: fileToUpload.type,
              name: fileToUpload.name,
              size: fileToUpload.size,
            },
          });
          setThemeDesign((prev) => ({
            ...prev,
            themeImageMobile: objectUrl,
            from: 1,
          }));
        };
        reader.readAsDataURL(fileToUpload);
        Swal.fire({
          title: "Warning!",
          text: "Successfully uploaded",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
      }
    } else if (val === 3) {
      let fileToUpload = e.target.files[0];
      const scriptFile = fileToUpload.type === "text/javascript";
      if (!scriptFile) {
        Swal.fire({
          title: "Error!",
          text: "Please upload file having extension .js only",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      } else {
        const objectUrl = URL.createObjectURL(fileToUpload);
        let reader = new FileReader();
        reader.onload = (event) => {
          setScriptSelected({
            link: objectUrl,
            blob: event.target.result,
            details: {
              type: fileToUpload.type,
              name: fileToUpload.name,
              size: fileToUpload.size,
            },
          });
        };
        reader.readAsDataURL(fileToUpload);
        setThemeDesign((prev) => ({
          ...prev,
          themeAnimationLink: objectUrl,
          from: 1,
        }));
        Swal.fire({
          title: "success!",
          text: "Successfully uploaded",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
      }
    }
  };

  const themeSubmitHandler = async (e) => {
    // e.preventDefault();
    const obj = { ...themeDesign };
    obj.background = backgroundState;
    if (backgroundState === 2) {
      obj.desktopImage = dbgSelectedImage;
      obj.mobileImage = mbgSelectedImage;
      obj.script = scriptSelected;
    }
    console.log("obj", obj);
    const data = await fetch(`${process.env.REACT_APP_API_URL}add-theme`, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-type": "application/json",
      },
    });
    const response = await data.json();
    if (response.status) {
      setTimeout(() => {
        nav("/admin/themes");
      }, 2000);
    } else {
      // error in add
    }
  };

  useEffect(() => {
    (async () => {
      if (id) {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}theme-details/${id}`
        );
        const resData = await response.json();
        if (resData.status === true) {
          console.log('resData.theme',resData.theme)
          setThemeDesign(resData.theme);
          setBackgroundState(resData.theme.background);
          setThemeUsers(resData.totalUsers);
        } else {
          // redirect to cms listing page
          nav("/admin/themes");
        }
      }
    })();
  }, [id, nav]);

  const deleteTheme = async() => {
    const obj = {
      _id: themeDesign._id,
      status: 2
    };
    const data = await fetch(`${process.env.REACT_APP_API_URL}delete-theme`, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-type": "application/json",
      },
    });
    const response = await data.json();
    if (response.status) {
      setTimeout(() => {
        nav("/admin/themes");
      }, 2000);
    } else {
      // error in add
    }
  };

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header d-block">
                  <div className="d-flex justify-content-between">
                    <h4 className="fs-20 d-block">{title}</h4>
                    <button
                      className="btn btn-primary btn-sm"
                      disabled={themeUsers > 0}
                      onClick={() => deleteTheme()}
                    >
                      <i className="fas fa-trash" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit(themeSubmitHandler)}>
                    <div className="row">
                      <div className="col-xl-12 col-md-12 mb-4">
                        <label className="form-label font-w600">
                          Theme Name
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          placeholder="Theme name"
                          aria-label="name"
                          name="name"
                          defaultValue={themeDesign.name}
                          {...register("name", {
                            required: "Name is Required",
                          })}
                          onChange={themeHandleChange}
                        />
                        {errors.name && (
                          <div style={{ color: "red" }}>
                            {errors.name.message}
                          </div>
                        )}
                      </div>

                      <div className="col-xl-12 col-md-12 mb-4">
                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="backgroundColor"
                            name="background"
                            checked={backgroundState === 1}
                            defaultValue="backgroundColor"
                            onChange={() => backgroundHandleChange(1)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="backgroundColor"
                          >
                            Background Color
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input solid"
                            id="backgroundImage"
                            name="background"
                            checked={backgroundState === 2}
                            defaultValue="backgroundImage"
                            onChange={() => backgroundHandleChange(2)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="backgroundImage"
                          >
                            Background Image
                          </label>
                        </div>
                      </div>

                      <div className="col-xl-12 col-md-12 mb-4">
                        {backgroundState === 1 && (
                          <React.Fragment>
                            <label className="form-label font-w600">
                              Background Color
                              <span className="text-danger scale5 ms-2">*</span>
                            </label>

                            <div className="input-group mb-3">
                              <input
                                type="text"
                                className="form-control solid"
                                placeholder="Theme color"
                                aria-label="color"
                                name="color"
                                value={themeDesign.color}
                                // defaultValue={themeDesign.color}
                                {...register("color", {
                                  required: "Background Color is Required",
                                })}
                                onChange={themeHandleChange}
                              />
                              <div className="input-group-text custom-color-picker">
                                <ColorPicker
                                  defaultColor={themeDesign.color}
                                  name={"color"}
                                  onColorChange={themeHandleChange}
                                />
                              </div>
                            </div>

                            {errors.color && (
                              <div style={{ color: "red" }}>
                                {errors.color.message}
                              </div>
                            )}
                          </React.Fragment>
                        )}

                        {backgroundState === 2 && (
                          <React.Fragment>
                            <div>
                              <label className="form-label font-w600">
                                Background Image For Desktop (1920*1080)
                                <span className="text-danger scale5 ms-2">
                                  *
                                </span>
                              </label>
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    style={{ display: "none" }}
                                    type="file"
                                    className="form-file-input form-control solid"
                                    id="background-image-desktop"
                                    accept="image/png, image/jpg"
                                    name="themeImageDesktop"
                                    title="Choose a Background image please"
                                    onChange={(event) => {
                                      changeBackgroundImage(event, 1);
                                    }}
                                  />
                                  <label
                                    className="custom-file-label mx-4 my-2"
                                    htmlFor="background-image-desktop"
                                  >
                                    Choose File
                                  </label>
                                </div>
                                <label
                                  className="input-group-text m-0"
                                  htmlFor="background-image-desktop"
                                >
                                  Upload
                                </label>
                              </div>
                            </div>
                            <div className="my-3">
                              <label className="form-label font-w600 my-2">
                                Background Image For Mobile (412*850)
                                <span className="text-danger scale5 ms-2">
                                  *
                                </span>
                              </label>
                              <div className="input-group mb-3">
                                <div className="form-file">
                                  <input
                                    style={{ display: "none" }}
                                    type="file"
                                    id="background-image-mobile"
                                    className="form-file-input form-control solid"
                                    accept="image/png, image/jpg"
                                    aria-label="imageMobile"
                                    name="themeImageMobile"
                                    onChange={(event) => {
                                      changeBackgroundImage(event, 2);
                                    }}
                                  />
                                  <label
                                    className="custom-file-label mx-4 my-2"
                                    htmlFor="background-image-mobile"
                                  >
                                    Choose File
                                  </label>
                                </div>
                                <label
                                  className="input-group-text m-0"
                                  htmlFor="background-image-mobile"
                                >
                                  Upload
                                </label>
                              </div>
                            </div>
                            <div className="my-3">
                              <label className="form-label font-w600 my-2">
                                Animation Script Link
                              </label>
                              <div className="input-group mb-3">
                                <div className="form-file">
                                  <input
                                    style={{ display: "none" }}
                                    type="file"
                                    id="animation-script"
                                    className="form-file-input form-control solid"
                                    accept="text/javascript"
                                    aria-label="AnimationLink"
                                    name="themeAnimationLink"
                                    onChange={(event) => {
                                      changeBackgroundImage(event, 3);
                                    }}
                                  />
                                  <label
                                    className="custom-file-label mx-4 my-2"
                                    htmlFor="animation-script"
                                  >
                                    Choose Js File
                                  </label>
                                </div>
                                <label
                                  className="input-group-text m-0"
                                  htmlFor="animation-script"
                                >
                                  Js
                                </label>
                              </div>
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Icon Color
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="Theme Icon Color"
                            aria-label="Icon Color"
                            name="iconColor"
                            value={themeDesign.iconColor}
                            // defaultValue={themeDesign.iconColor}
                            {...register("iconColor", {
                              required: "Icon color is required",
                            })}
                            onChange={themeHandleChange}
                          />
                          <div className="input-group-text custom-color-picker">
                            <ColorPicker
                              defaultColor={themeDesign.iconColor}
                              name={"iconColor"}
                              onColorChange={themeHandleChange}
                            />
                          </div>
                        </div>
                        {errors.iconColor && (
                          <div style={{ color: "red" }}>
                            {errors.iconColor.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Text Color
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="Theme Text color"
                            aria-label="Text color"
                            name="textColor"
                            value={themeDesign.textColor}
                            // defaultValue={themeDesign.textColor}
                            {...register("textColor", {
                              required: "Text color is required",
                            })}
                            onChange={themeHandleChange}
                          />
                          <div className="input-group-text custom-color-picker">
                            <ColorPicker
                              defaultColor={themeDesign.textColor}
                              name={"textColor"}
                              onColorChange={themeHandleChange}
                            />
                          </div>
                        </div>
                        {errors.textColor && (
                          <div style={{ color: "red" }}>
                            {errors.textColor.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Link Border Radius
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="Theme Border Radius"
                            aria-label="Border Radius"
                            name="borderRadius"
                            defaultValue={themeDesign.borderRadius}
                            autoComplete="off"
                            {...register("borderRadius", {
                              // required: "Border Radius is required",
                              pattern: {
                                value: /^[0-9]+$/i,
                                message: "Please enter radius in number format",
                              },
                            })}
                            onChange={themeHandleChange}
                          />
                          <div className="input-group-text">px</div>
                        </div>
                        {errors.borderRadius && (
                          <div className="my-1" style={{ color: "red" }}>
                            {errors.borderRadius.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Link Background Color
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="Theme LinkBackgroundColor"
                            aria-label="Link Background Color"
                            name="linkBackgroundColor"
                            value={themeDesign.linkBackgroundColor}
                            // defaultValue={themeDesign.linkBackgroundColor}
                            {...register("linkBackgroundColor", {
                              required: "Link Background color is required",
                            })}
                            onChange={themeHandleChange}
                          />
                          <div className="input-group-text custom-color-picker">
                            <ColorPicker
                              defaultColor={themeDesign.linkBackgroundColor}
                              name={"linkBackgroundColor"}
                              onColorChange={themeHandleChange}
                            />
                          </div>
                        </div>
                        {errors.linkBackgroundColor && (
                          <div style={{ color: "red" }}>
                            {errors.linkBackgroundColor.message}
                          </div>
                        )}
                      </div>
                      <div>
                        <button className="btn btn-secondary" type="submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <View theme={themeDesign} users={themeUsers} background={backgroundState} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ThemeForm;
